import { GetPostAppointmentStateUrlDto, useModalState } from '@monument/core';
import { PostAppointmentModalState } from './PostAppointmentContext';

export const usePostAppointmentClinicianRating = (
  postApptState?: GetPostAppointmentStateUrlDto,
): PostAppointmentModalState => {
  const clinicianRatingModalState = useModalState(true);
  const booking = postApptState?.clinicianRating;

  return {
    modal: {
      ...clinicianRatingModalState,
      visible: !!booking && clinicianRatingModalState.visible,
    },
    booking: booking?.reviewForBooking,
  };
};
